import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'

interface ModalDeleteFeatureValueProps extends ModalEditComponentProps { }

const ModalDeleteFeatureValue: React.FC<ModalDeleteFeatureValueProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/feature/featureValue/deleteFeatureValue',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteFeatureValue', '¿Seguro quieres eliminar esta característica?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteFeatureValue